import React from 'react';
import Slider from 'react-slick';
import _ from 'lodash';

const Carousel = ({ data, ...props }) => (
  <Slider {...props}>
    {data.map(obj => (
      <div key={_.uniqueId()}>
        <div style={{ backgroundColor: obj.backgroundColor }}>
          <img className="img-responsive" src={obj.url} alt={_.uniqueId()} />
        </div>
      </div>
    ))}
  </Slider>
);

Carousel.defaultProps = {
  autoplay: true,
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel.js